import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  businessOffersDelivery,
  mustCollectAddressForProfile,
} from '@/lib/assistant/assistantProfileUtils';

export function AssistantProfileDraftBar({
  profileDraft,
  setProfileDraft,
  business,
  primaryColor,
  onSubmit,
  onCancel,
  dockRef,
  dockStyle,
}) {
  if (profileDraft === null) return null;

  const showAddress = businessOffersDelivery(business);
  const addressRequired = mustCollectAddressForProfile(business);

  return (
    <div
      ref={dockRef}
      style={dockStyle}
      className="z-[60] bg-background/98 backdrop-blur border-t shadow-md pb-[max(0.5rem,env(safe-area-inset-bottom,0px))]"
    >
      <div className="max-w-4xl mx-auto px-4 py-4 space-y-3">
        <p className="text-sm font-medium">Tus datos para el pedido</p>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="space-y-1.5">
            <Label htmlFor="asst-profile-name">Nombre</Label>
            <Input
              id="asst-profile-name"
              value={profileDraft.name}
              onChange={(e) => setProfileDraft((p) => ({ ...p, name: e.target.value }))}
              autoComplete="name"
              data-testid="assistant-profile-name"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="asst-profile-phone">Teléfono</Label>
            <Input
              id="asst-profile-phone"
              type="tel"
              value={profileDraft.phone}
              onChange={(e) => setProfileDraft((p) => ({ ...p, phone: e.target.value }))}
              autoComplete="tel"
              data-testid="assistant-profile-phone"
            />
          </div>
        </div>
        {showAddress ? (
          <div className="space-y-1.5">
            <Label htmlFor="asst-profile-address">
              Dirección
              {!addressRequired ? ' (si pides delivery)' : ''}
            </Label>
            <Input
              id="asst-profile-address"
              value={profileDraft.address}
              onChange={(e) => setProfileDraft((p) => ({ ...p, address: e.target.value }))}
              autoComplete="street-address"
              placeholder={
                addressRequired ? 'Calle, número, comuna' : 'Opcional si vas a retirar en el local'
              }
              data-testid="assistant-profile-address"
            />
          </div>
        ) : null}
        <div className="flex flex-wrap gap-2 pt-1">
          <Button
            type="button"
            style={{ backgroundColor: primaryColor }}
            className="text-white"
            onClick={onSubmit}
            data-testid="assistant-profile-continue"
          >
            Guardar y seguir
          </Button>
          <Button type="button" variant="ghost" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}
